
import { fetchHotelCategory } from "../API/fetchHotelCategory";


export const getDateDifferenceInDays = (startDate, endDate) => {
    const diffTime = Math.abs(endDate - startDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
};



export const calculateTvaFacture = async (rows, selectedHotel) => {
    let tva = 0; 
    let customerDays = {};
    let passportX = {}; // Object to store x values for each passport

    const categ = await fetchHotelCategory(selectedHotel);
    console.log("categggggggg",categ);

    for (let i = 0; i < rows.length; i++) {
        const { passport, clientCheckIn, clientCheckOut, applytax, nationnalite } = rows[i];

        // Set x for each passport based on its nationality and the category
        if (nationnalite === 'MGR' && categ.category === 2) {
            passportX[passport] = 1; 
        } else if (nationnalite === 'MGR' && categ.category === 3) {
            passportX[passport] = 2; 
        } else if (nationnalite === 'MGR' && categ.category === 4) {
            passportX[passport] = 3; 
        } else if (nationnalite === 'MGR' && categ.category === 5) {
            passportX[passport] = 3; 
        } else if (nationnalite === 'ETR' && categ.category === 2) {
            passportX[passport] = 4; 
        } else if (nationnalite === 'ETR' && categ.category === 3) {
            passportX[passport] = 8; 
        } else if (nationnalite === 'ETR' && categ.category === 4) {
            passportX[passport] = 12; 
        } else if (nationnalite === 'ETR' && categ.category === 5) {
            passportX[passport] = 12; 
        }

        // Calculate stay duration for customers who apply tax
        if (applytax === 'oui' && nationnalite && categ) {
            const clientCheckOutDate = new Date(clientCheckOut);
            const clientCheckInDate = new Date(clientCheckIn);

            if (!isNaN(clientCheckOutDate) && !isNaN(clientCheckInDate)) {
                const stayDuration = getDateDifferenceInDays(clientCheckInDate, clientCheckOutDate);
                if (!customerDays[passport]) {
                    customerDays[passport] = 0;
                }
                customerDays[passport] += stayDuration;
            }
        }
    }

    // Calculate tva using the correct x value per passport
    for (let passport in customerDays) {
        const totalDays = customerDays[passport];
        const daysToCharge = totalDays > 10 ? 10 : totalDays;
        
        // Use the corresponding x value for this passport
        tva += daysToCharge * (passportX[passport] || 0); // Default to 0 if x isn't set for passport
    }

    console.log("customerDays",customerDays);
    console.log("passportX",passportX);

    console.log("tva", tva);
    return tva;
};








/*

import { fetchHotelCategory } from "../API/fetchHotelCategory";


export const getDateDifferenceInDays = (startDate, endDate) => {
    const diffTime = Math.abs(endDate - startDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
};



export const calculateTvaFacture = async (rows, selectedHotel) => {
    let tva = 0; 
    let customerDays = {};

    const categ =  await fetchHotelCategory (selectedHotel);

    for (let i = 0; i < rows.length; i++) {
        const { passport, clientCheckIn, clientCheckOut, applytax, nationnalite} = rows[i];
        

        if (applytax === 'oui' && nationnalite && categ) {
            const clientCheckOutDate = new Date(clientCheckOut);
            const clientCheckInDate = new Date(clientCheckIn);

            if (!isNaN(clientCheckOutDate) && !isNaN(clientCheckInDate)) {
                const stayDuration = getDateDifferenceInDays(clientCheckInDate, clientCheckOutDate);
                if (!customerDays[passport]) {
                    customerDays[passport] = 0;
                }
                customerDays[passport] += stayDuration;
            }
        }

        console.log("customerDaysssss",customerDays);
    }


        for (let passport in customerDays) {
            const totalDays = customerDays[passport];
            const daysToCharge = totalDays > 10 ? 10 : totalDays;
            tva += daysToCharge * 3;
        }

    return tva;
};

*/